import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Box, Button, ButtonGroup } from "@mui/material";
import deleteIcon from "@iconify/icons-mdi/delete";
import keyIcon from "@iconify/icons-mdi/key";
import minusIcon from "@iconify/icons-mdi/minus";
import plusIcon from "@iconify/icons-mdi/plus";
import { InlineIcon } from "@iconify/react";
import { useOcButtonGroup } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

type MyHrUsersFilterBarProps = {
  tableData: {
    filterField?: string;
    filterSelected?: string[];
    [key: string]: any;
  };
  setTableData: (
    data: Partial<{ filterField: string; filterSelected: string[] }>,
  ) => void;
  onNewUser: () => void;
  loading: boolean;
  dataLength: number;
  onAddGroupRole: () => void;
  onInactivateGroup: () => void;
  onRemoveGroupRole: () => void;
  onSendGroupPasswords: () => void;
};

export const MyHrUsersFilterBar = ({
  tableData,
  setTableData,
  onNewUser,
  loading,
  dataLength,
  onAddGroupRole,
  onInactivateGroup,
  onRemoveGroupRole,
  onSendGroupPasswords,
}: MyHrUsersFilterBarProps) => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();

  const buttonsDef = ["OC_ACTIVE", "OC_ALL"];
  const { OcButtonGroup, selectedButton } = useOcButtonGroup({
    id: "UsersFilterBar",
    buttonsDef,
  });

  let disabled = loading && dataLength === 0 ? true : false;

  const handleFilterChange = ({
    filterField,
    filterSelected,
  }: {
    filterField?: string;
    filterSelected?: string[];
  }) => {
    if (filterField && filterField !== tableData.filterField) {
      setTableData({ filterField });
    }
    if (
      filterSelected &&
      !_.isEqual(filterSelected, tableData.filterSelected)
    ) {
      setTableData({ filterSelected });
    }
  };

  useEffect(() => {
    if (selectedButton === "OC_ACTIVE") {
      handleFilterChange({
        filterField: "active",
        filterSelected: ["active"],
      });
    } else if (selectedButton === "OC_ALL") {
      handleFilterChange({
        filterField: "all",
        filterSelected: ["all"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedButton]);

  return (
    <Box>
      <Box>
        <Box
          display="flex"
          flexDirection={isMobile ? "column-reverse" : "row"}
          justifyContent="space-between"
        >
          <Box>
            <ButtonGroup
              orientation={isMobile ? "vertical" : "horizontal"}
              fullWidth={isMobile ? true : false}
            >
              <Button
                id="addGroupRole"
                name="addGroupRole"
                color="inherit"
                startIcon={<InlineIcon icon={plusIcon} />}
                onClick={onAddGroupRole}
              >
                {t("MY_HR_ADD_GROUP_ROLE")}
              </Button>
              <Button
                id="RemoveGroupRole"
                name="RemoveGroupRole"
                color="inherit"
                startIcon={<InlineIcon icon={minusIcon} />}
                onClick={onRemoveGroupRole}
              >
                {t("MY_HR_REMOVE_GROUP_ROLE")}
              </Button>
              <Button
                id="SendGroupPassword"
                name="SendGroupPassword"
                color="inherit"
                startIcon={<InlineIcon icon={keyIcon} />}
                onClick={onSendGroupPasswords}
              >
                {t("MY_HR_PASSWORD")}
              </Button>
              <Button
                id="inactive"
                name="inactive"
                color="inherit"
                startIcon={<InlineIcon icon={deleteIcon} />}
                onClick={onInactivateGroup}
              >
                {t("MY_HR_INACTIVATE_GROUP")}
              </Button>
            </ButtonGroup>
          </Box>
          {isMobile && <Box height="16px" />}
          <Button
            id="showDialog"
            name="showDialog"
            variant="contained"
            color="primary"
            startIcon={<InlineIcon icon={plusIcon} />}
            disabled={disabled}
            onClick={onNewUser}
            disableElevation
          >
            {t("MY_HR_NEW_USER")}
          </Button>
        </Box>
      </Box>
      <Box
        id="users-filter-bar-container"
        display="flex"
        alignItems="center"
        height="80px"
        paddingTop="16px"
        paddingBottom="16px"
      >
        <Box
          flexGrow={1}
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <OcButtonGroup />
        </Box>
      </Box>
    </Box>
  );
};

export default MyHrUsersFilterBar;
